// in-memory token store — lost on full page reload unless refreshed via refresh endpoint
let ACCESS_TOKEN: string | null = null;
export const getAccessToken = () => ACCESS_TOKEN;
export const setAccessToken = (t: string) => (ACCESS_TOKEN = t);
export const clearAccessToken = () => (ACCESS_TOKEN = null);
